import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { VIDEO_LOCAL_CLIPS_FETCH_LIMIT } from "./constants";
import { DEFAULT_SWIMLANE_LAYOUT } from "../LayoutFactory/constants";
import { getVideoItemsByCategorySlugs } from "../../fetch/graphql/requests/video/library";
import useLocalNewsRegion from "../../hooks/useLocalNewsRegion";
import RegionsListSelector from "../RegionInfo/components/RegionsListSelector/component";
import LayoutFactory, {
    getPlaceholderItems,
} from "../../components/LayoutFactory/component";
import { PLACEMENT } from "../RegionInfo/components/RegionsListSelector/constants";
import { SectionHeading } from "../Heading/component";
import useMounted from "../../hooks/useMounted";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { getPath } from "../../utils/path/library";
import log from "../../utils/logger/library";

export const VideoLocal = () => {
    const placeholders = getPlaceholderItems(VIDEO_LOCAL_CLIPS_FETCH_LIMIT);
    const [videoItems, setVideoItems] = useState(placeholders);
    const { pathname } = useLocation();
    const { region } = useLocalNewsRegion();
    const isMounted = useMounted();
    const path = getPath(pathname);

    const fetchMyLocalItems = async (categorySlug) => {
        if (!categorySlug) throw new Error("Invalid categorySlug!");

        try {
            const gqlResponse = await getVideoItemsByCategorySlugs(
                [categorySlug],
                VIDEO_LOCAL_CLIPS_FETCH_LIMIT
            );
            const nodes = gqlResponse?.data?.allContentItems?.nodes ?? [];
            const contentItems = transformAllContentItems(nodes) ?? [];

            const transformedVideoContentItems = contentItems?.length
                ? transformForLayouts(
                      contentItems,
                      DEFAULT_SWIMLANE_LAYOUT,
                      path
                  )
                : [];
            setVideoItems(transformedVideoContentItems);
        } catch (error) {
            log.error(`(VideoLocal) fetchMyLocalItems failed`, error);
        }
    };

    useEffect(() => {
        if (isMounted) {
            setVideoItems(placeholders);
            fetchMyLocalItems(region.categorySlug);
        }
    }, [region.categorySlug, isMounted]);

    return (
        <div className="videoLocal">
            <SectionHeading text={"My Local"} />
            {isMounted && (
                <div className="videoLocalRegionSelector">
                    <div className="videoLocalRegionLabel">{region.title}</div>
                    <div
                        className="videoLocalRegionListWrapper"
                        data-testid="videoLocalRegionListWrapper"
                    >
                        <RegionsListSelector placement={PLACEMENT.CONTENT} />
                    </div>
                </div>
            )}
            <LayoutFactory
                layout={DEFAULT_SWIMLANE_LAYOUT}
                items={videoItems}
            />
        </div>
    );
};

export default VideoLocal;
